export default __webpack_public_path__ + "static/media/bspring29.53046110.webp";